import React from "react";
import VideoHeader from "./components/headers/VideoHeader";
import FeatureTop from "./components/features/FeatureTop";
import Feature6_1 from "./components/features/FeatureBottom";
import Solutions from "./components/features/Solutions";
import Pricing1 from "./components/pricings/Pricing";
import Footer from "../../../views/Footer";
import Navbar from "./components/navbar/Navbar";
import MainFeatures from "./components/features/MainFeatures";


// Core Components

function WelcomePage() {
    React.useEffect(() => {
        document.body.classList.add("landing-page");
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
        return function cleanup() {
            document.body.classList.remove("landing-page");
        };
    });
    return (
        <>
            <Navbar type="transparent" />
            <div className="wrapper">
                <VideoHeader />
                <MainFeatures/>
                <Solutions />
                <Pricing1 />
                <Footer />
            </div>
        </>
    );
}

export default WelcomePage;
